import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { SectionForm, schema } from '../../../../../validations/section.validation';
import { Section } from '../../../../../entities';
import { Input, ScrollableTabPanel } from '../../../../../components';

interface SectionsPanelProps {
  visible: boolean;
  section: Section;
  onClickClose: () => void;
  onSubmit: (value: Section) => void;
}

export const SectionsPanel = ({ visible, section, onClickClose, onSubmit }: SectionsPanelProps): JSX.Element => {
  const {
    register,
    reset,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<SectionForm>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  useEffect(() => {
    reset({
      label: section.label || '',
    });
  }, [section, reset]);

  return (
    <ScrollableTabPanel
      direction="left"
      visible={visible}
      loading={isSubmitting}
      onClickClose={onClickClose}
      onClickSubmit={handleSubmit(() => onSubmit({ ...section, ...getValues() }))}
      title="Descrição da sessão"
    >
      <Input
        label="nome do bloco"
        placeholder="Ex: 01"
        validationRegister={register('label')}
        error={Boolean(errors.label)}
        helperText={errors.label?.message || ' '}
      />
    </ScrollableTabPanel>
  );
};

export default SectionsPanel;
